import TermsAndConditions from "./TermsAndConditions";

export default TermsAndConditions;
